module.exports = __webpack_public_path__ + "static/media/5.2e4e3088.jpeg";